<template>
    <div class="mb-3 mb-md-4" v-if="detailData">
       

        <div class="block" >
            <div class="block_label">
               <label class="mb-0">{{label}} :</label>
                <span>{{ currentActive.label }}</span>
                
            </div>
            <div class="over_flow">
                <div class="block_flex" ref="scrollContainer">
                    
                    <div class="box text-center"  v-for="list in dropdownOptions" :key="list.value + list.icon" @click="toggleOption(list.value)" :class="{'active ': list.selected === 1, 'disabled': list.visibility === 0}">
                        <div>
                            <img v-if="list.icon ==='white'" width="50" height="50" src="~/assets/metals/white.png" alt="white gold"/>
                            <img v-if="list.icon ==='yellow'" width="50" height="50" src="~/assets/metals/yellow.png" alt="yellow gold"/>
                            <img v-if="list.icon ==='rose'" width="50" height="50" src="~/assets/metals/rose.png" alt="rose gold"/>
                        </div>  
                        <!-- <SvgMetalSvg v-if="list.icon != null" :type="list.selected === 1 ? list.icon + '_active' : list.icon" />     -->
                        <span :class="{ 'border_box': list.icon === null , 'border_box-active': list.selected === 1 && list.icon === null }" v-if="label === 'Metal'" class="metal_label">{{list.short_label}}</span>
                        <span :class="{ 'border_box': list.icon === null , 'border_box-active': list.selected === 1 && list.icon === null }" v-else>{{list.label}}</span>
                    </div>
                </div>
            </div>
            
        </div>
        
        
        <div class="error_boxx" v-if="mode">{{ mode.join(" ") }}</div>

        <p class="mb-0 pt-1" v-if="detailData.sub_type === 'full-eternity-ring' && attr === 'size'" >* Eternity rings cannot be resized. <router-link :to="localePath('/customer-service/ring-resizing')">Read more</router-link></p>

    </div>
 
</template>

<script setup>

    import { shopdetailStore }  from '@/stores/shop_detail/shop_detail';
    const store = shopdetailStore()
    const scrollContainer = ref('')
    const startX = ref(0);
    const isDown = ref(false)
    const scrollLeft = ref(0);
    const localePath = useLocalePath();
    const route = useRoute()
    const router = useRouter()


    const { type, label, mode, attr } = defineProps(['type', 'label', 'mode', 'attr'])

    const showOptions = ref(false)

    const detailData = computed(() => {
        return store.getDetailData
    })

    const dropdownOptions = computed(() => {
        return store.getDropDownList(type)
    })

    const currentActive = computed(() => {
        return store.getCurrentActive(type)
    })

    watch( 
        () => route.params.slug,
        (nv) => {
                
            // Ensure options are available and non-empty
            const availableOptions = dropdownOptions.value || [];

            if (availableOptions.length === 0) return;
            
            if( type === 'carat' ){

                const activeMetal = availableOptions.find(option => option.slug === nv);
                const activeCarat = store.getCurrentActive('carat');

                if (!activeMetal || !activeCarat) return;

                if (activeMetal.value !== activeCarat.value) {
                    store.setActive({ value: activeMetal.value, type });
                }
                store.setAdditionalDetails({ slug: route.params.slug })
                // if(detailData.value.sub_type === 'hoop-earring'){
                // }
            }

            if( type === 'metal' ){

                let activeMetal = availableOptions.find(metal => 
                    metal?.carats?.some(carat => carat?.slug === nv)
                )?.value;

                if (activeMetal && activeMetal !== currentActive.value?.value) {
                    store.setActive({ value: activeMetal, type });
                }

            }
        }
    )

    function toggleOption(value){

        showOptions.value = false

        if( !(type == 'metal' || type == 'carat')){

            store.setActive({ value: value, type: type })
            return;
        }
       
        // below url changes
        const availableOptions = dropdownOptions.value || [];
        if (availableOptions.length === 0) return;

        // Find the active metal by slug
        const activeOption = availableOptions.find(option => option.value === value);
        
        if( !activeOption) return

        if( type === 'carat' ){

            router.push( { name: route.name, params:{ slug : activeOption.slug }, query: route.query  } )
            return
        }

        if( type === 'metal' ){

            const aciveCarat = store.getCurrentActive('carat')

            if( ! aciveCarat ) return

            const carat = activeOption.carats.find(option => option.value === aciveCarat.value);
            if( ! carat ) return
            router.push( { name: route.name, params:{ slug : carat.slug }, query: route.query },  )
        }            
    
       
    }

    function initHorizontalScroll() {
        if(scrollContainer.value){
            const scroll_Container = scrollContainer.value;

            scroll_Container.addEventListener('mousedown', (e) => {
                isDown.value = true;
                startX.value = e.pageX - scroll_Container.offsetLeft;
                scrollLeft.value = scroll_Container.scrollLeft;
            });

            scroll_Container.addEventListener('mouseleave', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mouseup', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mousemove', (e) => {
                if (!isDown.value) return;
                e.preventDefault();
                const x = e.pageX - scroll_Container.offsetLeft;
                const walk = (x - startX.value) * 3; // Adjust scrolling speed here
                scroll_Container.scrollLeft = scrollLeft.value - walk;
            });
        }
    }

    onMounted(() => {
        initHorizontalScroll();   
    })

</script>

<style scoped>
  .skeleton {
        height: 42px;
        border-radius: 8px;
        background: #eaeaea;
        min-width: 85px;
    }
.current_active .svg-head {
    height: 12px;
    width: 20px;
}
p{
    font-size: 12px;
    font-weight: 600;
}
p a{
    color: var(--green);
}

.drop_block.invalid .current_active {
    border: 1px solid rgb(255, 2, 2);
}
.label_box {
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    color: #212529;
}
.label_box div{
    color: rgb(159, 158, 158);
    cursor: pointer;
}
label{
    color: #303030;
    font-size: 16px;
    font-weight: 600;
}
.drop_block{
    position: relative;
}
.current_active {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #c4c4c4;
    padding: 0 10px;
    font-size: 14px;
    cursor: pointer;
    height: 44px;
    border-radius: 8px;
}


.current_active.focused {
    border-color: var(--green);
    box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
}
ul {
    border: 1px solid #c4c4c4;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9;
    padding: 10px 0;
    max-height: 220px;
    overflow: auto;
    border-radius: 8px;
}
ul li{
    list-style: none;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    text-transform: capitalize;
}
ul li.active {
    background: rgba(204,204,204,0.36863);
}
ul li.disabled {
    opacity: 0.4;
    pointer-events: none;
}
span{
    font-weight: 400;
    font-size: 14px;
    color: #212529;
    text-transform: capitalize;
}


.block {
    /* border-bottom: 1px solid #f5f5f5; */
    /* border-top: 1px solid #f5f5f5; */
    /* padding: 8px 0; */
}
.block_label {
    display: flex;
    align-items: center;
}

.block_label label {
    text-transform: capitalize;
    font-weight: 600;
    font-size: 16px;
}

.box .metal_label{
    text-transform: uppercase;
}
.block_label span {
    text-transform: capitalize;
    font-weight: 600;
    color: var(--green);
    margin-left: 10px;
    font-size: 16px;
}

.block_flex {
    display: flex;
    align-items: flex-start;
    padding: 2% 0 0;
    gap: 20px;
    /* overflow-x: scroll; */
    overflow-y: hidden;
    padding-bottom: 2%;
}

/* width */
::-webkit-scrollbar {
    width: 2px;
    height: 3px;
  
}

/* Track */
.block_flex::-webkit-scrollbar-track {
    background: #f5f5f5; 
}

/* Handle */
.block_flex::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
    
}

/* Handle on hover */
.block_flex::-webkit-scrollbar-thumb:hover {
    background: #c4c4c4; 
}

.box {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    /* gap: 6px; */
    align-items: flex-start;
}

.box span {
    color: #606060;
    font-size: 14px;
    text-transform: capitalize;
    min-width: 46px;
    display: inline-block;
    text-align: center;
}

.box.active span {
    color: var(--green);
    font-weight: 600;
}

.border_box {
    border: 1px solid #c4c4c4;
    width: max-content;
    border-radius: 4px;
    padding: 8px 12px;
}

.border_box-active  {
    border: 1px solid var(--green);
}



@media(max-width: 1050px){
    .over_flow {
        overflow-x: scroll;
        overflow-y: hidden;
    }

    .block_flex {
        min-width: 450px;
    }
}
@media(max-width: 767px){
    .block_label label,
    .block_label Span  {
        font-size: 14px;
    }

    .box span {
        font-size: 12px;
    }
    .block {
        border-bottom: 2px solid #f5f5f5;
        /* border-top: 2px solid #f5f5f5; */
        padding: 20px 0;
        /* padding-bottom: 18px; */
    }
    
    .block_flex {
       
        padding-bottom: 6px;
    }


}
</style>
